import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ProgettoModal from '@/components/feature/ProgettoModal';
import CookieConsent from '@/components/feature/CookieConsent';

interface PageLayoutProps {
  children: React.ReactNode;
}

const PageLayout = ({ children }: PageLayoutProps) => {
  const [progettoOpen, setProgettoOpen] = useState(false);

  return (
    <>
      <Navbar onProgettoClick={() => setProgettoOpen(true)} />
      {children}
      <Footer onProgettoClick={() => setProgettoOpen(true)} />
      <ProgettoModal isOpen={progettoOpen} onClose={() => setProgettoOpen(false)} />
      <CookieConsent />
    </>
  );
};

export default PageLayout;
